<template>
  <v-container fluid>
    <v-simple-table v-if="mpptShow">
      <template v-slot:default>
        <tr>
          <th>MPPT</th>
          <th>전압 (V)</th>
          <th>전류 (A)</th>
          <th>전력 (kW)</th>
        </tr>
        <tr>
          <td>MPPT 1</td>
          <td>{{unitedSolra.Umppt1}}</td>
          <td>{{unitedSolra.Imppt1}}</td>
          <td>{{unitedSolra.Wmppt1}}</td>
        </tr>
        <tr>
          <td>MPPT 2</td>
          <td>{{unitedSolra.Umppt2}}</td>
          <td>{{unitedSolra.Imppt2}}</td>
          <td>{{unitedSolra.Wmppt2}}</td>
        </tr>
        <tr>
          <td>MPPT 3</td>
          <td>{{unitedSolra.Umppt3}}</td>
          <td>{{unitedSolra.Imppt3}}</td>
          <td>{{unitedSolra.Wmppt3}}</td>
        </tr>
        <tr>
          <td>MPPT 4</td>
          <td>{{unitedSolra.Umppt4}}</td>
          <td>{{unitedSolra.Imppt4}}</td>
          <td>{{unitedSolra.Wmppt4}}</td>
        </tr>
        <tr>
          <td>MPPT 5</td>
          <td>{{unitedSolra.Umppt5}}</td>
          <td>{{unitedSolra.Imppt5}}</td>
          <td>{{unitedSolra.Wmppt5}}</td>
        </tr>
        <tr>
          <td>MPPT 6</td>
          <td>{{unitedSolra.Umppt6}}</td>
          <td>{{unitedSolra.Imppt6}}</td>
          <td>{{unitedSolra.Wmppt6}}</td>
        </tr>
        <tr>
          <td>MPPT 7</td>
          <td>{{unitedSolra.Umppt7}}</td>
          <td>{{unitedSolra.Imppt7}}</td>
          <td>{{unitedSolra.Wmppt7}}</td>
        </tr>
        <tr>
          <td>MPPT 8</td>
          <td>{{unitedSolra.Umppt8}}</td>
          <td>{{unitedSolra.Imppt8}}</td>
          <td>{{unitedSolra.Wmppt8}}</td>
        </tr>
        <tr>
          <td>MPPT 9</td>
          <td>{{unitedSolra.Umppt9}}</td>
          <td>{{unitedSolra.Imppt9}}</td>
          <td>{{unitedSolra.Wmppt9}}</td>
        </tr>
        <tr>
          <td>MPPT 10</td>
          <td>{{unitedSolra.Umppt10}}</td>
          <td>{{unitedSolra.Imppt10}}</td>
          <td>{{unitedSolra.Wmppt10}}</td>
        </tr>
        <tr>
          <td>MPPT 11</td>
          <td>{{unitedSolra.Umppt11}}</td>
          <td>{{unitedSolra.Imppt11}}</td>
          <td>{{unitedSolra.Wmppt11}}</td>
        </tr>
        <tr>
          <td>MPPT 12</td>
          <td>{{unitedSolra.Umppt12}}</td>
          <td>{{unitedSolra.Imppt12}}</td>
          <td>{{unitedSolra.Wmppt12}}</td>
        </tr>
        <tr>
          <td>MPPT 13</td>
          <td>{{unitedSolra.Umppt13}}</td>
          <td>{{unitedSolra.Imppt13}}</td>
          <td>{{unitedSolra.Wmppt13}}</td>
        </tr>
        <tr>
          <td>MPPT 14</td>
          <td>{{unitedSolra.Umppt14}}</td>
          <td>{{unitedSolra.Imppt14}}</td>
          <td>{{unitedSolra.Wmppt14}}</td>
        </tr>
        <tr>
          <td>MPPT 15</td>
          <td>{{unitedSolra.Umppt15}}</td>
          <td>{{unitedSolra.Imppt15}}</td>
          <td>{{unitedSolra.Wmppt15}}</td>
        </tr>
        <tr>
          <td>Total</td>
          <td></td>
          <td></td>
          <td>{{powerSum}}</td>
        </tr>
        <tr>
          <td>누설전류</td>
          <td colspan="3"> {{unitedSolra.GFCI ? unitedSolra.GFCI : 0}} mA</td>
        </tr>
      </template>
    </v-simple-table>
    <div v-else>
      <div>
        <h1 id="a">인버터별로 조회해 주세요</h1>
      </div>
    </div>
  </v-container>
</template>

<script>
import { getSolraUnitedInverterWork } from '@/api/pcs/siteWork'

let intervalWorkState

export default {
  props: {
    tabIndex: {
      type: Number,
      default: 0
    },
    SITE_ID: { type: String, default: '' },
    STATION_ID: { type: String, default: '' },
    INVERTER_ID: { type: String, default: '' }
  },
  data() {
    return {
      powerSum: 0,
      isMppt: false,
      mpptShow: false,
      tempArr: [],

      smpPrice: '0',
      timeWork: {},
      unitedSolra: {
        Imppt1: 0,
        Imppt2: 1
      }
    }
  },
  created() {
    if (this.tabIndex === 0) {
      this.mpptShow = false
    } else {
      this.mpptShow = true
      this.getSolraUnitedInverterWorkDate()
    }
  },
  watch: {
    tabIndex() {
      if (this.tabIndex === 0) {
        this.mpptShow = false
      } else {
        this.mpptShow = true
        this.getSolraUnitedInverterWorkDate()
      }
    }
  },
  methods: {
    getSolraUnitedInverterWorkDate() {
      let params =
        '?site_id=' +
        this.SITE_ID +
        '&station_id=' +
        this.STATION_ID +
        '&inverter_id=' +
        this.INVERTER_ID
      getSolraUnitedInverterWork(params).then(res => {
        this.unitedSolra = res.unitedSiteInfo
        if (this.unitedSolra.isMppt === '12.0') {
          this.powerSum = (
            Number(this.unitedSolra.Wmppt1) +
            Number(this.unitedSolra.Wmppt2) +
            Number(this.unitedSolra.Wmppt3) +
            Number(this.unitedSolra.Wmppt4) +
            Number(this.unitedSolra.Wmppt5) +
            Number(this.unitedSolra.Wmppt6) +
            Number(this.unitedSolra.Wmppt7) +
            Number(this.unitedSolra.Wmppt8) +
            Number(this.unitedSolra.Wmppt9) +
            Number(this.unitedSolra.Wmppt10) +
            Number(this.unitedSolra.Wmppt11) +
            Number(this.unitedSolra.Wmppt12) +
            Number(this.unitedSolra.Wmppt13) +
            Number(this.unitedSolra.Wmppt14) +
            Number(this.unitedSolra.Wmppt15)
          ).toFixed(1)
        } else if (this.unitedSolra.isMppt === '10.0') {
          this.powerSum = (
            Number(this.unitedSolra.Wmppt1) +
            Number(this.unitedSolra.Wmppt2) +
            Number(this.unitedSolra.Wmppt3) +
            Number(this.unitedSolra.Wmppt4) +
            Number(this.unitedSolra.Wmppt5) +
            Number(this.unitedSolra.Wmppt6) +
            Number(this.unitedSolra.Wmppt7) +
            Number(this.unitedSolra.Wmppt8) +
            Number(this.unitedSolra.Wmppt9) +
            Number(this.unitedSolra.Wmppt10)
          ).toFixed(1)
        } else if (this.unitedSolra.isMppt === '3.0') {
          this.powerSum = (
            Number(this.unitedSolra.Wmppt1) +
            Number(this.unitedSolra.Wmppt2) +
            Number(this.unitedSolra.Wmppt3)
          ).toFixed(1)
        } else if (this.unitedSolra.isMppt === '0.0') {
          this.powerSum = 0
        }

        if (this.unitedSolra.isMppt) {
          this.isMppt = true
        }
        this.startTimer()
      })
    },
    startTimer() {
      this.stopTimer()
      intervalWorkState = setInterval(() => {
        this.getSolraUnitedInverterWorkDate()
      }, 60000 * 2)
    },
    stopTimer() {
      if (intervalWorkState) {
        clearInterval(intervalWorkState)
      }
      intervalWorkState = null
    }
  }
}
</script>

<style lang="less" scoped>
.workSearchBtn {
  width: 30%;
  height: 28px;
  float: left;
  background-color: #2976d2;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  padding-top: 4px;
}

#info-box {
  height: 500px;
}

#realgrid {
  height: 392px;
  // width: 100%;
  // margin-top: 0;
  // margin-bottom: 20px;
  // margin-left: auto;
  // margin-right: auto;
}

.excel_down {
  width: 100px;
  height: 30px;
  border: 1px solid #24943e;
  color: #24943e;
  text-align: center;
  line-height: 30px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;
  background-color: #fff;
}

#a {
  text-align: center;
  font-weight: bold;
  margin-top: 200px;
}

table {
  margin-top: 50px;
  width: 100%;
}
table,
th,
td {
  border: 1px solid rgb(0, 0, 0);
  border-collapse: collapse;
}
th,
td {
  font-size: 20px;
  padding: 15px;
  text-align: center;
}
#t01 tr:nth-child(even) {
  background-color: #eee;
  color: #000;
}
#t01 tr:nth-child(odd) {
  background-color: #fff;
  color: #000;
}
#t01 th {
  background-color: rgb(15, 113, 240);
  color: white;
  text-align: center;
}

.table-header-bg {
  /*background-color: var(--v-hth-base);*/
  background-color: var(--v-sitetableheader-base);
}
</style>
